import {
  memo, useState,
} from 'react';
import {
  Accordion, AccordionHeaderSize,
} from '~/_shared/baseComponents/accordion';
import type { PlaceId } from '~/places/places.types';
import type { PlacesSearchId } from '~/store/mapSettings/places/mapSettingsPlaces.state';
import { PlacesListingHeaderComponent } from './placesListingHeader.component';
import { PlacesListingPlaceDetailsComponent } from './placesListingPlaceDetails.component';
import type { PlaceSearchListingItem } from './placesTool.container';
import { getPlacesMarkerProps } from './placesTool.helpers';
import { placesSearchItemPanelStyle } from './placesTool.styles';

const PlacesToolListingComponent = ({
  expandedSearches,
  searches,
  onToggleSearch,
  onSearchHovered,
  onSearchHoverStopped,
}: {
  expandedSearches: ReadonlySet<PlaceId>;
  searches: ReadonlyArray<PlaceSearchListingItem>;
  onToggleSearch: (searchId: PlaceId) => void;
  onSearchHovered: (searchId: PlacesSearchId) => void;
  onSearchHoverStopped: () => void;
}) => {
  const [activeContextMenuSearchId, setActiveContextMenuSearchId] = useState<null | PlacesSearchId>(null);

  const getPlaceContextMenuProps = ((placeSearchId: PlacesSearchId) => ({
    isContextMenuVisible: activeContextMenuSearchId === placeSearchId,
    onHideContextMenu: () => setActiveContextMenuSearchId(null),
    onOpenContextMenu: () => setActiveContextMenuSearchId(placeSearchId),
  }));

  return (
    <Accordion>
      {searches.map(search => {
        const markerProps = getPlacesMarkerProps({ placeColor: search.color });

        return (
          <Accordion.Item
            key={search.id}
            onMouseEnter={() => onSearchHovered(search.id)}
            onMouseLeave={onSearchHoverStopped}
            open={expandedSearches.has(search.id)}
            onToggle={() => onToggleSearch(search.id)}
          >
            <Accordion.ItemHeading
              size={AccordionHeaderSize.Flexible}
            >
              <PlacesListingHeaderComponent
                markerVisualizerProps={markerProps}
                contextMenuProps={getPlaceContextMenuProps(search.id)}
                place={search}
              />
            </Accordion.ItemHeading>
            <Accordion.Panel
              css={placesSearchItemPanelStyle}
            >
              {search.items.map((item, index) => {
                return (
                  <PlacesListingPlaceDetailsComponent
                    key={item.id}
                    place={item}
                    index={index}
                    color={search.color}
                  />
                );
              })}
            </Accordion.Panel>
          </Accordion.Item>
        );
      })}
    </Accordion>
  );
};

const pureComponent = memo(PlacesToolListingComponent);
export { pureComponent as PlacesToolListingComponent };
